<template>
  <div class="d-flex flex-column align-center">
    <v-carousel
      hide-delimiters
      :show-arrows="$vuetify.breakpoint.xs ? false : true"
      @change="onChange($event)"
      height="auto"
    >
      <v-carousel-item v-for="(image, i) in images" :key="i">
        <div style="height: auto">
          <img
            style="max-width: 100%"
            :src="`https://chalkidiki.mobics.gr/images/${image.image[0].file_name}`"
            class="mb-4"
          />
          <div
            class="d-flex flex-column align-center mt-auto mb-3"
            style="width: 100%"
          >
            <div
              class="text-center"
              style="font-weight: medium; font-size: 16px"
            >
              {{ currentImage.image[0].name }}
            </div>
            <v-divider width="80%" class="mt-3 mb-5"> </v-divider>
            <div
              v-html="currentImage.image[0].description"
              class="text-center"
              style="font-weight: 300; font-size: 14px"
            ></div>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>

    <div class="d-flex">
      <v-icon
        class="mr-2"
        v-for="(image, i) in images"
        :key="i"
        color="white"
        size="10"
      >
        {{ image.id == currentImage.id ? "mdi-circle" : "mdi-circle-outline" }}
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: Array,
    initialImage: Object,
  },

  created() {
    this.currentImage = this.images[0];
  },

  data() {
    return {
      currentImage: null,
    };
  },

  watch: {
    initialImage(newImage, oldImage) {
      this.currentImage = this.images[0];
    },
  },

  methods: {
    onChange(event) {
      this.currentImage = this.images[event];
    },
  },
};
</script>

<style></style>
